var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"payment-ways-main"},[_c('div',{staticClass:"payment-row clearfix"},[_c('div',{staticClass:"payment-col",staticStyle:{"color":"#8f919a"}},[_vm._v(" "+_vm._s(_vm.$t("paymentways.payment_method"))+" ")]),_c('div',{staticClass:"payment-col",staticStyle:{"text-align":"left","margin-bottom":"10px"}},[(
          _vm._options.selected.categorys?.payment.includes('alipay') &&
          _vm.selectPayment(_vm._options.selected.categorys?.payments, `alipay`) !==
            false &&
          _vm.selectPayment(
            _vm._options.selected.categorys?.payments,
            `alipay`
          ).hasOwnProperty('tags') &&
          _vm.selectPayment(_vm._options.selected.categorys?.payments, `alipay`)
            .tags !== null
        )?_c('el-badge',{staticClass:"badge-discount",staticStyle:{"margin-right":"10px","margin-left":"10px"},attrs:{"value":_vm.selectPayment(_vm._options.selected.categorys?.payments, `alipay`)
            .tags[0].tags[0]}},[(
            !_vm.$session?.mark.is('JAPAN_SPECIAL_USER') &&
            _vm._options.selected.categorys?.payment.includes('alipay')
          )?_c('el-button',{class:[
            'payment-btn',
            _vm.$i18n.locale === 'zh-CN' ? 'payment-alipay' : 'payment-alipay-en',
            _vm._options.selected.paymentType === 'alipay' ? 'select' : '',
          ],attrs:{"id":"collect_payment-zfb"},on:{"click":function($event){return _vm.changePaymentType('alipay')}}}):_vm._e()],1):_vm._e(),(
          !_vm.$session?.mark.is('JAPAN_SPECIAL_USER') &&
          _vm._options.selected.categorys?.payment.includes('alipay') && !_vm.selectPayment(_vm._options.selected.categorys?.payments, `alipay`).tags
        )?_c('el-button',{class:[
          'payment-btn',
          _vm.$i18n.locale === 'zh-CN' ? 'payment-alipay' : 'payment-alipay-en',
          _vm._options.selected.paymentType === 'alipay' ? 'select' : '',
        ],attrs:{"id":"collect_payment-zfb"},on:{"click":function($event){return _vm.changePaymentType('alipay')}}}):_vm._e(),(
          _vm._options.selected.categorys?.payment.includes('wxpay') &&
          _vm.selectPayment(_vm._options.selected.categorys?.payments, `wxpay`) !==
            false &&
          _vm.selectPayment(
            _vm._options.selected.categorys?.payments,
            `wxpay`
          ).hasOwnProperty('tags') &&
          _vm.selectPayment(_vm._options.selected.categorys?.payments, `wxpay`)
            .tags !== null
        )?_c('el-badge',{staticClass:"badge-discount",staticStyle:{"margin-right":"10px","margin-left":"10px"},attrs:{"value":_vm.selectPayment(_vm._options.selected.categorys?.payments, `wxpay`)
            .tags[0].tags[0]}},[(
            !_vm.$session?.mark.is('JAPAN_SPECIAL_USER') &&
            _vm._options.selected.categorys?.payment.includes('wxpay')
          )?_c('el-button',{class:[
            'payment-btn',
            _vm.$i18n.locale === 'zh-CN' ? 'payment-wxpay' : 'payment-wxpay-en',
            _vm._options.selected.paymentType === 'wxpay' ? 'select' : '',
          ],attrs:{"id":"collect_payment-wx"},on:{"click":function($event){return _vm.changePaymentType('wxpay')}}}):_vm._e()],1):_vm._e(),(
          !_vm.$session?.mark.is('JAPAN_SPECIAL_USER') &&
          _vm._options.selected.categorys?.payment.includes('wxpay') && !_vm.selectPayment(_vm._options.selected.categorys?.payments, `wxpay`).tags
        )?_c('el-button',{class:[
          'payment-btn',
          _vm.$i18n.locale === 'zh-CN' ? 'payment-wxpay' : 'payment-wxpay-en',
          _vm._options.selected.paymentType === 'wxpay' ? 'select' : '',
        ],attrs:{"id":"collect_payment-wx"},on:{"click":function($event){return _vm.changePaymentType('wxpay')}}}):_vm._e(),(
          _vm._options.selected.paymentCoupon === null && (_vm._options.selected.paymentDiscountCode === null || _vm._options.selected.paymentDiscountCode === '') &&
          _vm._options.selected.categorys?.payment.includes('vdcard') &&
          _vm.selectPayment(_vm._options.selected.categorys?.payments, `vdcard`) !==
            false &&
          _vm.selectPayment(
            _vm._options.selected.categorys?.payments,
            `vdcard`
          ).hasOwnProperty('tags') &&
          _vm.selectPayment(_vm._options.selected.categorys?.payments, `vdcard`)
            .tags !== null
        )?_c('el-badge',{staticClass:"badge-discount",staticStyle:{"margin-right":"10px","margin-left":"10px"},attrs:{"value":_vm.selectPayment(_vm._options.selected.categorys?.payments, `vdcard`)
            .tags[0].tags[0]}},[(_vm._options.selected.categorys?.payment.includes('vdcard'))?_c('el-button',{class:[
            'payment-btn',
            _vm.$i18n.locale === 'zh-CN' ? 'payment-vdpay' : 'payment-vdpay-en',
            _vm._options.selected.paymentType === 'vdcard' ? 'select' : '',
          ],attrs:{"id":"collect_payment-vd"},on:{"click":_vm.openOptionGiftcards}}):_vm._e()],1):_vm._e(),(
          _vm._options.selected.categorys?.payment.includes('vdcard') &&
          !_vm.selectPayment(_vm._options.selected.categorys?.payments, `vdcard`).tags
        )?_c('el-button',{class:[
          'payment-btn',
          _vm.$i18n.locale === 'zh-CN' ? 'payment-vdpay' : 'payment-vdpay-en',
          _vm._options.selected.paymentType === 'vdcard' ? 'select' : '',
        ],attrs:{"disabled":_vm._options.selected.paymentCoupon !== null || (_vm._options.selected.paymentDiscountCode !== null && _vm._options.selected.paymentDiscountCode !== ''),"id":"collect_payment-vd"},on:{"click":_vm.openOptionGiftcards}}):_vm._e(),(
          _vm._options.selected.categorys?.payment.includes('payssion.alipay') &&
          _vm.selectPayment(
            _vm._options.selected.categorys?.payments,
            `payssion.alipay`
          ) !== false &&
          _vm.selectPayment(
            _vm._options.selected.categorys?.payments,
            `payssion.alipay`
          ).hasOwnProperty('tags') &&
          _vm.selectPayment(
            _vm._options.selected.categorys?.payments,
            `payssion.alipay`
          ).tags !== null
        )?_c('el-badge',{staticClass:"badge-discount",staticStyle:{"margin-right":"10px","margin-left":"10px"},attrs:{"value":_vm.selectPayment(
            _vm._options.selected.categorys?.payments,
            `payssion.alipay`
          ).tags[0].tags[0]}},[(
            !_vm.$session?.mark.is('JAPAN_SPECIAL_USER') &&
            _vm._options.selected.categorys?.payment.includes('payssion.alipay')
          )?_c('el-button',{class:[
            'payment-btn',
            _vm.$i18n.locale === 'zh-CN'
              ? 'payment-payssion-zfb'
              : 'payment-payssion-zfb',
            _vm._options.selected.paymentType === 'payssion.alipay'
              ? 'select'
              : '',
          ],attrs:{"id":"collect_payment-ps-zfb"},on:{"click":function($event){return _vm.changePaymentType('payssion.alipay')}}}):_vm._e()],1):_vm._e(),(
          !_vm.$session?.mark.is('JAPAN_SPECIAL_USER') &&
          _vm._options.selected.categorys?.payment.includes('payssion.alipay') &&
          !_vm.selectPayment(
            _vm._options.selected.categorys?.payments,
            `payssion.alipay`
          ).tags
        )?_c('el-button',{class:[
          'payment-btn',
          _vm.$i18n.locale === 'zh-CN'
            ? 'payment-payssion-zfb'
            : 'payment-payssion-zfb',
          _vm._options.selected.paymentType === 'payssion.alipay' ? 'select' : '',
        ],attrs:{"id":"collect_payment-ps-zfb"},on:{"click":function($event){return _vm.changePaymentType('payssion.alipay')}}}):_vm._e(),(
          _vm._options.selected.categorys?.payment.includes('payssion.wechat') &&
          _vm.selectPayment(
            _vm._options.selected.categorys?.payments,
            `payssion.wechat`
          ) !== false &&
          _vm.selectPayment(
            _vm._options.selected.categorys?.payments,
            `payssion.wechat`
          ).hasOwnProperty('tags') &&
          _vm.selectPayment(
            _vm._options.selected.categorys?.payments,
            `payssion.wechat`
          ).tags !== null
        )?_c('el-badge',{staticClass:"badge-discount",staticStyle:{"margin-right":"10px","margin-left":"10px"},attrs:{"value":_vm.selectPayment(
            _vm._options.selected.categorys?.payments,
            `payssion.wechat`
          ).tags[0].tags[0]}},[(
            !_vm.$session?.mark.is('JAPAN_SPECIAL_USER') &&
            _vm._options.selected.categorys?.payment.includes('payssion.wechat')
          )?_c('el-button',{class:[
            'payment-btn',
            _vm.$i18n.locale === 'zh-CN'
              ? 'payment-payssion-wx'
              : 'payment-payssion-wx',
            _vm._options.selected.paymentType === 'payssion.wechat'
              ? 'select'
              : '',
          ],attrs:{"id":"collect_payment-ps-zfb"},on:{"click":function($event){return _vm.changePaymentType('payssion.wechat')}}}):_vm._e()],1):_vm._e(),(
          !_vm.$session?.mark.is('JAPAN_SPECIAL_USER') &&
          _vm._options.selected.categorys?.payment.includes('payssion.wechat') &&
          !_vm.selectPayment(
            _vm._options.selected.categorys?.payments,
            `payssion.wechat`
          ).tags
        )?_c('el-button',{class:[
          'payment-btn',
          _vm.$i18n.locale === 'zh-CN'
            ? 'payment-payssion-wx'
            : 'payment-payssion-wx',
          _vm._options.selected.paymentType === 'payssion.wechat' ? 'select' : '',
        ],attrs:{"id":"collect_payment-ps-zfb"},on:{"click":function($event){return _vm.changePaymentType('payssion.wechat')}}}):_vm._e(),(
          _vm.$session?.mark.is('CAN_USE_PAYPAL') &&
          !_vm.$session?.mark.is('JAPAN_SPECIAL_USER') &&
          _vm._options.selected.categorys?.payment.includes('paypal') &&
          _vm.selectPayment(_vm._options.selected.categorys?.payments, `paypal`) !==
            false &&
          _vm.selectPayment(
            _vm._options.selected.categorys?.payments,
            `paypal`
          ).hasOwnProperty('tags') &&
          _vm.selectPayment(_vm._options.selected.categorys?.payments, `paypal`)
            .tags !== null
        )?_c('el-badge',{staticClass:"badge-discount",staticStyle:{"margin-right":"10px","margin-left":"10px"},attrs:{"value":_vm.selectPayment(_vm._options.selected.categorys?.payments, `paypal`)
            .tags[0].tags[0]}},[(
            _vm.$session?.mark.is('CAN_USE_PAYPAL') &&
            !_vm.$session?.mark.is('JAPAN_SPECIAL_USER') &&
            _vm._options.selected.paymentShowPaypal
          )?_c('el-button',{class:[
            'payment-btn',
            _vm.$i18n.locale === 'zh-CN' ? 'payment-pppay' : 'payment-pppay-en',
            _vm._options.selected.paymentType === 'paypal' ? 'select' : '',
          ],attrs:{"id":"collect_payment-pp"},on:{"click":function($event){return _vm.changePaymentType('paypal')}}}):_vm._e()],1):_vm._e(),(
          !_vm.$session?.mark.is('JAPAN_SPECIAL_USER') &&
          _vm.$session?.mark.is('CAN_USE_PAYPAL') &&
          _vm._options.selected.paymentShowPaypal &&
          !_vm.selectPayment(_vm._options.selected.categorys?.payments, `paypal`).tags
        )?_c('el-button',{class:[
          'payment-btn',
          _vm.$i18n.locale === 'zh-CN' ? 'payment-pppay' : 'payment-pppay-en',
          _vm._options.selected.paymentType === 'paypal' ? 'select' : '',
        ],attrs:{"id":"collect_payment-pp"},on:{"click":function($event){return _vm.changePaymentType('paypal')}}}):_vm._e(),(_vm._options.selected.paymentDesc)?_c('div',{staticClass:"payment-way-tips"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm._options.selected.paymentDesc)}})]):_vm._e()],1)]),_c('payment-new-v-d-card-dialog',{ref:"vdcard-dialog",attrs:{"options":_vm._options,"payment-cards":_vm.paymentCards},on:{"paymentChange":_vm.discountChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }